import React from "react"
import { Cover } from "./styles"

export default function CoverContainer(){
    return <Cover />
}
